import {useOpenModal} from '@/components/Modal'
import {useMapContext} from '@/components/MindMap/index.mjs'
import ErrNodeReplaceDlg from '@/pages/MainPage/panes/ErrNodeReplaceConfigList/ErrNodeReplaceDlg.jsx'

export default () => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const {bizNodeType, pkid, prjId, sVer} = map.root.data

    if (! /^(BD|UI)$/.test(bizNodeType)) {
        return null
    }

    const onClick = async () => {
        await openModal(
            <ErrNodeReplaceDlg
                dpBizNodeType={bizNodeType}
                dpId={pkid}
                prjId={prjId}
                sVer={sVer}
            />
        )

        await map.refreshMap()
    }

    return {
        key: 'fix-ai-generated',
        label: '容错性补全',
        onClick,
    }
}
